module.exports = __webpack_public_path__ + "static/media/ptcs_logo2.5153730b.svg";